import { render, staticRenderFns } from "./widget-outerForm.vue?vue&type=template&id=b272a912&scoped=true"
import script from "./widget-outerForm.vue?vue&type=script&lang=js"
export * from "./widget-outerForm.vue?vue&type=script&lang=js"
import style0 from "./widget-outerForm.vue?vue&type=style&index=0&id=b272a912&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b272a912",
  null
  
)

export default component.exports